const clearLocalStorage = (isSetCredUpdate) => {
    let affiliate_id = localStorage.getItem("affiliate_id")
    let x_device_id = localStorage.getItem("x_device_id")
    window.localStorage.clear();
    localStorage.setItem("isLightMode", true)
    if(affiliate_id) localStorage.setItem("affiliate_id", affiliate_id)
    if(x_device_id) localStorage.setItem("x_device_id", x_device_id)
    if(isSetCredUpdate === true) localStorage.setItem("isCredentialsUpdate", true);
    return;
}

export default clearLocalStorage;